import React, { useRef, useState } from "react";
import { Alert, Box } from "@mui/material";
import LaddaButton from "../buttons/laddaButton";
import ImagePreview, { resolveImagePreviewSource } from "./imagePreview";
import { compressEvidenceImage } from "../../utils/compressEvidenceImage";

const ImageUploadButton = ({ onImageChange, buttonText, path, disabled = false, isViewer = false, onProcessingChange, allowClear = true, loading = false }) => {
  const inputRef = useRef(null);
  const actionRef = useRef(false);
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState("");
  const blocked = disabled || isViewer || processing || loading;
  const chooseImage = () => { if (!blocked && !actionRef.current) inputRef.current?.click(); };
  const changeImage = async (file) => {
    if (blocked || actionRef.current) return;
    if (onProcessingChange?.(true) === false) return;
    actionRef.current = true;
    setProcessing(true);
    setError("");
    try {
      await onImageChange(file ? await compressEvidenceImage(file) : null);
    } catch (failure) {
      setError(failure?.message || "No se pudo preparar la imagen. Intenta de nuevo.");
    } finally {
      actionRef.current = false;
      setProcessing(false);
      onProcessingChange?.(false);
    }
  };
  return <Box>
    <ImagePreview source={resolveImagePreviewSource(path)} busy={processing || loading} disabled={blocked}
      onSelect={isViewer ? undefined : chooseImage} />
    <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/gif" hidden disabled={blocked}
      onChange={(event) => { const file = event.target.files?.[0]; event.target.value = ""; if (file) changeImage(file); }} />
    {error && <Alert severity="error" sx={{ mt: 1 }}>{error}</Alert>}
    {!isViewer && <Box className="no-print" sx={{ display: "flex", justifyContent: "center", gap: 1, mt: 1 }}>
      <LaddaButton type="button" disabled={blocked} loading={processing} onClick={chooseImage}>
        {path ? "Cambiar imagen" : buttonText || "Agregar imagen"}
      </LaddaButton>
      {path && allowClear && <LaddaButton type="button" disabled={blocked} loading={false}
        backgroundColor="white" color="#6A6AD8" borderColor="#6A6AD8" onClick={() => changeImage(null)}>Quitar selección</LaddaButton>}
    </Box>}
  </Box>;
};

export default ImageUploadButton;
